import { noGAEventParams, sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * 発火タイミング：モーダルを開いてから最初に文字を入力した際（モーダル1開封につき1回）。
 * 流入元ページは GA4 標準の `page_location` / `page_path` で分かるため、独自パラメータは持たない。
 */
export const sendGAWabunkaSearchInputStartedEvent = () => {
  sendWabunkaGAEvent('search_input_started', noGAEventParams);
};
